export default "__VITE_ASSET__kf03zvIu__"